/**
 * Helper utilities for handling redirect URLs after authentication
 */

const REDIRECT_STORAGE_KEY = 'auth_redirect_url';

/**
 * Get redirect URL from query params or sessionStorage
 * Falls back to default route if none specified
 */
export function getRedirectUrl(defaultRoute: string = '/profile'): string {
  // First, check URL query params (for direct login page access)
  const urlParams = new URLSearchParams(window.location.search);
  const redirectParam = urlParams.get('redirect');
  
  if (redirectParam) {
    // Validate that it's a relative URL (security)
    if (redirectParam.startsWith('/') && !redirectParam.startsWith('//')) {
      // Save to sessionStorage for OAuth flows
      sessionStorage.setItem(REDIRECT_STORAGE_KEY, redirectParam);
      return redirectParam;
    }
  }
  
  // Check sessionStorage (for OAuth flows that redirect to another page)
  const storedRedirect = sessionStorage.getItem(REDIRECT_STORAGE_KEY);
  if (storedRedirect) {
    // Validate stored URL
    if (storedRedirect.startsWith('/') && !storedRedirect.startsWith('//')) {
      return storedRedirect;
    }
  }
  
  return defaultRoute;
}

/**
 * Save redirect URL to sessionStorage (for OAuth flows)
 */
export function saveRedirectUrl(url: string): void {
  // Validate that it's a relative URL (security)
  if (url.startsWith('/') && !url.startsWith('//')) {
    sessionStorage.setItem(REDIRECT_STORAGE_KEY, url);
  }
}

/**
 * Clear redirect URL from sessionStorage
 */
export function clearRedirectUrl(): void {
  sessionStorage.removeItem(REDIRECT_STORAGE_KEY);
}

